import request from '@/Utilities/httpRequest';
import websiteEvents from '@/Utilities/website-events';
import pdpUtils from '@/store/product-page/pdp-utils';
//import utilities from '@/Utilities/common';
//import operatingSystem from '@/Utilities/operating-system';

import {cloneDeep, isEmpty} from 'lodash-es';

function initialState(){
    return {
        controllerError: false,
        currency: '',
        productStatus: '',
        noOptionsProduct: false,
        qtyLimit: 1,
        cartItemQty: 1,
        showQuantityWidget: false,
        showSoloQtyBtn: false,
        floatBtn: { // aka add to cart button that detaches on scroll
            label: '',
            mode: '',
            loadingBar: 0, // width
            warningLabel: '',
            detached: false,
            selectionWarning: '',
            pointsBtn: null // points purchase btn -> see in updateSelectionData an example
        },
        canAddToCart: false, // !important
        globalCartWarningEvent: false, // for dynamic packs -> review this state
        // packs
        isPack: false,
        packData: {},
        //packItemsLabel: '', // pack options list label
        // selection widget settings
        selectedProduct: {}, // !important -> for normal product
        selectedPackProducts: [], // !important -> for pack product -> VUE DOES NOT LIKE COMPUTED OBJECTS ARRAY
        readyPackItems: [], // 
        numberOfReadyPackItems: 0, // 
        selectionData: {}, // selection widget data builder
        // cart popup controls !IMPORTANT
        showOptionsPopup: '', // primary, secondary or qty
        showPagePopup: '', // pack, stock form, nutrition table, comments etc...
        // forms & notifications
        toastNotification: null, // only for stock alert
        stockAlertForm: { // stock alert form
            action: '',
            method: 'post',
            email: '',
            variant: {
                label: '',
                description: '',
                availableDate: '',
            },
            // hidden values
            notificationSku: '',
            actionValue: 'INSERT',
            isGroup: false
        },
        headerCartQty: 0,
    };
}

const addToCartDesktop = {
    strict: true,
    namespaced: true,
    state: initialState,
    mutations: {
        setControllerError(state, payload) {
            state.controllerError = payload;
        },
        setCurrency(state, payload) {
            state.currency = payload;
        },
        setProductStatus(state, payload) {
            state.productStatus = payload;
        },
        setNoOptionsProduct(state, payload) {
            state.noOptionsProduct = payload;
        },
        setNoOptionsProduct(state, payload) {
            state.noOptionsProduct = payload;
        },
        setIsPack(state, payload) {
            state.isPack = payload;
        },
        setPackData(state, payload) {
            state.packData = payload;
        },
        setCanAddToCart(state, payload) {
            state.canAddToCart = payload;
        },
        setGlobalCartWarningEvent(state, payload) {
            state.globalCartWarningEvent = payload;
        },
        setCartItemQty(state, payload) {
            state.cartItemQty = payload;
        },
        setQtyLimit(state, payload) {
            state.qtyLimit = payload;
        },
        setShowQuantityWidget(state, payload) {
            state.showQuantityWidget = payload;
        },
        setShowSoloQtyBtn(state, payload) {
            state.showSoloQtyBtn = payload;
        },
        setFloatBtn(state, payload) {
            state.floatBtn = Object.assign({}, state.floatBtn, payload);
        },
       /* setPackItemsLabel(state, payload) {
            state.packItemsLabel = payload;
        },*/
        setSelectionData(state, payload) {
            state.selectionData = Object.assign({}, state.selectionData, payload);
        },
        setShowOptionsPopup(state, payload) {
            state.showOptionsPopup = payload;
        },
        setShowPagePopup(state, payload) {
            state.showPagePopup = payload;
        },
        setSelectedProduct(state, payload) {
            state.selectedProduct = payload;
        },
        setSelectedPackProducts(state, payload) {
            // payload ex -> {index: this.itemIndex, selectedProduct: this.selectedProduct}
            if(!isEmpty(payload)) {
                state.selectedPackProducts.splice(payload.index, 1, payload.selectedProduct);
                //state.selectedPackProducts[payload.index] = payload.selectedProduct;
            }
        },
        setReadyPackItems(state, payload) {
            // ex {index: 0, sku: x}
            //state.readyPackItems =  Object.assign({}, state.readyPackItems, payload);
            state.readyPackItems[payload.index] = payload.ready;
            state.numberOfReadyPackItems = state.readyPackItems.filter(elm => elm).length;
        },
        setStockAlertForm(state, payload) {
            state.stockAlertForm = Object.assign({}, state.stockAlertForm, payload);
        },
        setToastNotification(state, payload) {
            state.toastNotification = payload;
        },
        reset(state){
          // acquire initial state
          const s = initialState()
          Object.keys(s).forEach(key => {
            state[key] = s[key]
          });
        },
        setHeaderCartQty(state, payload) {
          state.headerCartQty = payload;
        }
    },

    actions: {
        // state, commit, dispatch, rootState, rootGetters
        async initCartData(context, payload, dispatch, rootState, rootGetters) {
            //console.log('init AddToCart PLAYLOAD: ', payload);
            try {
                context.dispatch('pdpDesktop/setLoading', false, {root: true});
                if(payload.cartAuxData) {
                    context.dispatch('updateCurrency', payload.cartAuxData.cartAddFormInfo);
                }
                context.commit('setProductStatus', payload.productInfo.groupStatus);
                context.dispatch('updateHasStock', payload.productInfo.hasStock, {root: true});
                context.dispatch('updateShowQuantityWidget', payload.productInfo.showQuantity);
                if(payload.productInfo.groupStatus != 'DE') {
                    context.dispatch('updateSelectionData', payload);
                }
                context.commit('setHeaderCartQty', payload.cartProducts.length);
                if(payload.hasOwnProperty('cartPointsInfo')) {
                    context.dispatch('updateCartPointsInfo', payload.cartPointsInfo, {root: true});
                }
            } catch (e) {
                context.commit('setControllerError', true);
                //console.log('Add To Cart mount failure!', e);
                if(typeof Bugsnag !== 'undefined'){
                    Bugsnag.notify('addToCart', 'Failed to set data', {}, 'error');
                }
            } finally {
                //context.dispatch('pdpDesktop/initMovingElementsBehaviour', '', {root: true});
            }
        },
        updateSelectedProduct(context, payload) {
            context.commit('setQtyLimit', payload.hasOwnProperty('stock') ? Math.min( payload.stock, 5) : 5);
            context.commit('setCartItemQty', 1);
            // todo update stock alert form here
            context.commit('setSelectedProduct', payload);
            if(payload.pointsPurchaseData) {
                context.dispatch('updateFloatBtn', pdpUtils.buildPointsButtonData(payload.pointsPurchaseData));
            } else {
                context.dispatch('updateFloatBtn', {pointsBtn: null});
            }
        },
        updateSelectedPackProducts(context, payload) {
            //console.log('pack product update: ', payload);
            context.commit('setSelectedPackProducts', payload);
        },
        updateReadyPackItems(context, payload) {
            context.commit('setReadyPackItems', payload);
        },
        updateCurrency(context, payload) {
            const currency = payload.currency ? payload.currency : App.js.getConfig('currency');
            context.commit('setCurrency', currency);
        },
        updateProductStatus(context, payload) {
            // todo ADD OVERRIDE status HERE
            context.commit('setProductStatus', payload);
        },
        updateShowQuantityWidget(context, payload) {
            if(payload) {
                //context.commit('setQtyLimit', 5);
                let showBtn = !context.getters.isPack && context.getters.noOptionsProduct && context.getters.qtyLimit > 1;
                context.commit('setShowSoloQtyBtn', showBtn);
            }
            context.commit('setShowQuantityWidget', payload);
        },
        updateFloatBtn(context, payload) {
            context.commit('setFloatBtn', payload);
        },
        updateCartItemQty(context, payload) {
            //console.log('update cart item qty: ', payload);
            context.commit('setCartItemQty', payload);
        },
        updateCanAddToCart(context, payload) {
            context.commit('setCanAddToCart', payload);
        },
        updateGlobalCartWarningEvent(context, payload) {
            context.commit('setGlobalCartWarningEvent', payload);
        },
        updateSelectionData(context, payload) {
            // packs
            if (payload.productType === 'pack' || payload.productType === 'packStatic') {
                context.commit('setPackData', {
                    items: payload.pack,
                    fieldKeys: payload.fieldKeys,
                    basePackInfo: payload.productInfo,
                    packType: payload.productType,
                });
                context.commit('setIsPack', true);
                //context.commit('setPackItemsLabel', `${packData.items.length} items (${packData.items.map(product => product.productInfo && product.productInfo.name).join(', ')})`);

            } else if(payload.productComponentDefault && Object.keys(payload.productComponentDefault).length > 0) { // normal products
                context.commit('setSelectionData', {
                    productsList: payload.products,
                    optionTypes: payload.optionTypes,
                    fieldKeys: payload.fieldKeys,
                    componentOrder: payload.productComponentDefault,
                    singleOption: payload.productComponentDefault.length == 1,
                });
            } else { // no options / no variants
                context.commit('setSelectedProduct', payload.products[0]);
                context.commit('setQtyLimit', payload.products[0].hasOwnProperty('stock') ? Math.min( payload.products[0].stock, 5) : 5);
                context.commit('setNoOptionsProduct', true);
                if(payload.products.length > 1){
                    websiteEvents.addEvent('CONTEXT_FE_PDP', 'noComponentDefault', payload.products.length, {});
                }
            }

            // pre-fill Notification form;
            context.dispatch('updateStockAlertForm', {
                action: payload.cartAuxData.notificationFormInfo.actionUrl,
                method: 'post',
                email: payload.cartAuxData.notificationFormInfo.email, // if logged in, email must be set
                variant: {
                    label: '',
                    description: '',
                    availableDate:  !isEmpty(context.getters.selectedProduct) ? context.getters.selectedProduct.availableDate : '',
                },
                // hidden values
                notificationSku: !isEmpty(context.getters.selectedProduct) ? context.getters.selectedProduct.sku : payload.productInfo.sku,
                actionValue: 'INSERT',
                isGroup: !isEmpty(context.getters.selectedProduct)
            });

            // // set base points floatBtn data (ex: products with variants with no selection by user
            // if(!context.getters.isPack && payload.products.length) {
            //     context.dispatch('updateFloatBtn', pdpUtils.buildPointsButtonData(null, payload.products, payload.productInfo.sku));
            // } else {
            //     context.dispatch('updateFloatBtn', {pointsBtn: null});
            // }
        },
        updateToastNotification(context, payload) {
            context.commit('setToastNotification', payload);
            setTimeout(() => {
                context.commit('setToastNotification', null);
            }, 7500);
        },
        updateShowOptionsPopup(context, payload) {
            context.commit('setShowOptionsPopup', payload);
        },
        updateShowPagePopup(context, payload) {
            //let mobilenavBarmobilenavBar = document.getElementById('nav-mob-bottom');
           // let isIOS = operatingSystem.isIOS();
           /* if(!payload) {
                utilities.enableBodyScroll();
                //mobilenavBar && mobilenavBar.classList.remove('nav-force-hide');
            } else {
                utilities.disableBodyScroll();
            }*/

            //context.commit('setShowOptionsPopup', '');
            context.commit('setShowPagePopup', payload);
        },
        updateStockAlertForm(context, payload) {
            //console.log('form update: ', payload);
            context.commit('setStockAlertForm', payload);
        },
        async updateProzisPoints(context, payload) {
            if(payload.hasOwnProperty('points') && (payload.points > 0)) {
                let superPoints = payload.hasOwnProperty('superPoints') && payload.superPoints;
                context.dispatch('pdpDesktop/updateInfoSection', {points: payload.points, superPoints: superPoints}, {root: true});
            } else {
                try {
                    let updateUrl = context.rootState.pdpDesktop.prozisPointsUpdateUrl;
                    const {data} = await request.get(updateUrl, {groupId: payload.groupId, skuEncoded: encodeURIComponent(payload.sku)});
                    //console.log('variant points update: ', data);
                    context.dispatch('pdpDesktop/updateInfoSection', {points: data}, {root: true});
                } catch (e) {
                    //console.log('points update failure!', e);
                    if(typeof Bugsnag !== 'undefined') {
                        Bugsnag.notify('pointsUpdate', 'failed to update variant points', {}, 'error');
                    }
                }
            }
        },
        runTrackers(context, payload) {
            let data = null;
            if (context.getters.productType === 'pack') {
                data = context.getters.selectedPackProducts.map(product => product);
            } else if (this.productType === 'packStatic') {
                data = context.getters.packData.basePackInfo;
            } else {
                data = context.getters.selectedProduct;
            }

            let variant = '';
            if (data.flavorId) {
                variant = data.flavorLabelDescription + ':' + data.flavorDescription;
            }
            if (data.optionId && variant) {
                variant = variant + ',' + data.optionLabelDescription + ':' + data.optionDescription;
            }
            if (data.optionId && !variant) {
                variant = data.optionLabelDescription + ':' + data.optionDescription;
            }

            if (data && typeof gtag === 'function') {
                gtag('event', 'add_to_cart', {
                    'value': data.priceVal,
                    'items': [
                        {
                            'id': data.groupId,
                            'google_business_vertical': 'retail'
                        }
                    ]
                });
            }

            if (typeof App.js.vars !== 'undefined') {
                // vue dev mode
                // tracker info build (App.js.getConfig not working well)
                if (!(typeof App.js.vars.trackerInfo === 'undefined' || App.js.vars.trackerInfo === null)) {
                    let trackerInfo = App.js.vars.trackerInfo;
                    // facebook pixel
                    if (typeof fbq === 'function') {
                        let store = trackerInfo.store.toUpperCase();
                        let language = trackerInfo.language.toUpperCase();
                        let groupId = trackerInfo.groupId;
                        let groupIdStore = store + '_' + groupId;
                        if (store == 'BE' && (language == 'FR' || language == 'NL')) {
                            groupIdStore = store + '_' + language + '_' + groupId;
                        } else if (store == 'BE') {
                            groupIdStore = store + '_' + 'FR' + '_' + groupId;
                        }
                        if (store == 'CH' && (language == 'FR' || language == 'DE')) {
                            groupIdStore = store + '_' + language + '_' + groupId;
                        } else if (store == 'CH') {
                            groupIdStore = store + '_' + 'FR' + '_' + groupId;
                        }

                        let facebookPixel = {
                            content_name: encodeURIComponent(trackerInfo.productName),
                            content_category: '',
                            content_ids: [groupIdStore],
                            content_type: 'product',
                            value: context.getters.isPack ? context.getters.selectedProduct
                                ? context.getters.selectedProduct.price
                                : trackerInfo.productPrice : null,
                            currency: trackerInfo.productCurrency,
                        };
                            fbq('track', 'AddToCart', facebookPixel);
                    }

                    // google analytics
                    if (typeof ga_actionInCart === 'function') {
                        let googleAnalytics = {
                            id: trackerInfo.groupId,
                            name: trackerInfo.productName,
                            brand: trackerInfo.productBrand,
                            variant: context.getters.selectedProduct.sku ? context.getters.selectedProduct.sku : trackerInfo.productSku,
                            quantity: context.getters.cartItemQty,
                            price: trackerInfo.productPriceEur,
                            category: trackerInfo.productClassification,
                        };
                        ga_actionInCart(googleAnalytics, 'add', 'Add to cart');
                    }
                }
            }

            //Criteo Tracker, only for US Store
            let criteoData = context.rootState.pdpDesktop.criteoData;
            if (Object.keys(criteoData).length > 0) {// Criteo Add to Cart Tag
                window.criteo_q = window.criteo_q || [];
                let deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                let cartId = 'addtocart_' + criteoData.cartId;
                window.criteo_q.push(
                    { event: "setAccount", account: criteoData.accountId },
                    { event: "setEmail", email: criteoData.md5Email, hash_method: "md5" },
                    { event: "setSiteType", type: deviceType},
                    { event: "setZipcode", zipcode: criteoData.zipCode },
                    { event: "addToCart", id: cartId, item: [
                            {id: context.getters.selectedProduct.groupId, price: data.priceVal, quantity: context.getters.cartItemQty }
                        ]}
                );
                window.criteo_q.push(
                    { event: "setAccount", account: criteoData.accountId },
                    { event: "setEmail", email: criteoData.md5Email, hash_method: "md5" },
                    { event: "setSiteType", type: deviceType},
                    { event: "setZipcode", zipcode: criteoData.zipCode },
                    { event: "trackTransaction", id: cartId, item: [
                            {id: context.getters.selectedProduct.groupId, price:  data.priceVal, quantity: context.getters.cartItemQty }
                        ]}
                );
            }
            // START RTB House Advertising Tracking
            let rtbhEvents = window.rtbhEvents || [];
            const value = `${document.cookie}`;
            const parts = /__vh_ot\=([^;]*)/g.exec(value);
            const { store } = App.js.currentStore();
            rtbhEvents.push({
                eventType: 'basketadd',
                offerId: store + '-' + context.getters.selectedProduct.groupId
            }, 
            {
                eventType: 'custom', 
                name: 'country', 
                value: store
            },
            {
                eventType: 'uid',
                id:  parts[1] ? parts[1] : null
            });
            // END RTB House Advertising Tracking

        },
        // !important -> by groupID change only
        async updatePageContent(context, payload) {
            if(context.getters.isPack) {
                return
            }

            let currentGroupId = context.rootGetters.GroupId;
            // by groupId updates all content

            if(currentGroupId && (currentGroupId != payload.groupId)) { // just in case
                //console.log('previousGroupId: ', currentGroupId);
                //console.log('newGroupId: ', payload.groupId);
                context.dispatch('pdpDesktop/setLoading', true, {root: true});
                const loadUrl = context.rootState.pdpDesktop.loadUrl;
                const {data} = await request.get(loadUrl, {_id: payload.groupId});
                //data.ignoreCartUpdate = true; // ignore cartUpdate
                try {
                    //console.log('groupID page update: ', data);
                    context.dispatch('updateDomContent', data.addToCart.productInfo);
                    //context.dispatch('changeGroupId', payload.groupId, {root: true});
                    context.dispatch('pdpDesktop/initWsData', data, {root: true});
                } catch (e) {
                    //console.log('groupID page update failure!', e);
                    if(typeof Bugsnag !== 'undefined'){
                        Bugsnag.notify('groupID PAGE update failure!', 'failed to set data', {}, 'error');
                    }
                } finally {
                    context.dispatch('pdpDesktop/setLoading', false, {root: true});
                }
            }
        },

        // ex: by varSku (secondary options) updates partial content, prices, images, etc
        updatePagePartialContent(context, payload) {
            if(context.getters.isPack) {
                return
            }
            context.dispatch('changeSKU', {sku: payload.varSku}, {root: true});
            if(payload.type != 'sizeId') { // update images if radio types -> size selectors
                context.dispatch('gallery/setSKU', payload.varSku, {root: true});
                context.dispatch('gallery/setGroupId', payload.groupId, {root: true});
            }
            //context.dispatch('updateHasStock', payload.stock > 0, {root: true}); // update stock label too if needed
            // update price
            context.dispatch('updatePrice', {price: payload.price, priceReference: payload.partnerPrice, bestPriceCoupon: payload.bestPriceCoupon}, {root: true});
            // update points
            context.dispatch('updateProzisPoints', {groupId: payload.groupId, sku: payload.varSku, points: payload.points, superPoints: payload.superPoints});
        },
        updateDomContent(context, productInfoData) {
            pdpUtils.updateDomContent(productInfoData);
        },
        reset(context){
            context.commit('reset');
        },
        updateHeaderCartQty(context, payload) {
           context.commit('setHeaderCartQty', payload);
        },
        updateImmersivePoints(context, payload) {
            context.dispatch('updateCartPointsInfo', payload, {root: true});
            const updatedCartPointsInfo = context.rootGetters.cartPointsInfo;
            const pointsUpdateKStrings = context.rootGetters.kStrings.pointsUpdateKStrings;
            // update ALL variants that have pointsPurchaseData
            const selectionData = cloneDeep(context.getters.selectionData);
            if(!isEmpty(selectionData) && !isEmpty(updatedCartPointsInfo) && !isEmpty(pointsUpdateKStrings)) {
                selectionData.productsList = selectionData.productsList.map(obj => {
                    if (obj.pointsPurchaseData) {
                        obj.pointsPurchaseData.disableButton = obj.pointsPurchaseData.cost > updatedCartPointsInfo.immersiveTotal;
                        obj.pointsPurchaseData.availablePoints = updatedCartPointsInfo.immersiveTotal;
                        obj.pointsPurchaseData.difference = Math.abs(updatedCartPointsInfo.immersiveTotal - obj.pointsPurchaseData.cost);
                        obj.pointsPurchaseData.noticeLabel = obj.pointsPurchaseData.cost > updatedCartPointsInfo.immersiveTotal  ? pointsUpdateKStrings.noticeLabel_negative : pointsUpdateKStrings.noticeLabel_positive;
                        let modalDescription = obj.pointsPurchaseData.modalDescription;
                        if(obj.pointsPurchaseData.cost > updatedCartPointsInfo.immersiveTotal) {
                            modalDescription = pointsUpdateKStrings.modalDescription_negative.replace('{{points}}', obj.pointsPurchaseData.cost).replace('{{price}}', obj.pointsPurchaseData.priceCost).replace('{{difference}}', obj.pointsPurchaseData.difference);
                        } else {
                            modalDescription = pointsUpdateKStrings.modalDescription_positive.replace('{{points}}', obj.pointsPurchaseData.cost).replace('{{price}}', obj.pointsPurchaseData.priceCost);
                        }
                        obj.pointsPurchaseData.modalDescription = modalDescription;

                        return { ...obj, obj };
                    }
                    return obj;
                });
                context.commit('setSelectionData', selectionData);
            }
        }
    },
    getters: {
        controllerError: state => state.controllerError,
        currency: state => state.currency,
        productStatus: state => state.productStatus,
        showQuantityWidget: state => state.showQuantityWidget,
        showSoloQtyBtn: state => state.showSoloQtyBtn,
        floatBtn: state => state.floatBtn,
        qtyLimit: state => state.qtyLimit,
        canAddToCart: state => state.canAddToCart,
        cartItemQty: state => state.cartItemQty,
        globalCartWarningEvent: state => state.globalCartWarningEvent,
        noOptionsProduct: state => state.noOptionsProduct,
        isPack: state => state.isPack,
        packData: state => state.packData,
        selectionData: state => state.selectionData,
        selectedProduct: state => state.selectedProduct,
        selectedPackProducts: state => state.selectedPackProducts,
        readyPackItems: state => state.readyPackItems,
        numberOfReadyPackItems: state => state.numberOfReadyPackItems,
        showOptionsPopup: state => state.showOptionsPopup,
        showPagePopup: state => state.showPagePopup,
        toastNotification: state => state.toastNotification,
        stockAlertForm: state => state.stockAlertForm,
        headerCartQty: state => state.headerCartQty,
    },
};

export default addToCartDesktop;
